import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import { getCreatorChatUnreadCount } from '../lib/chat-api';

/**
 * Unread-messages indicator for the Creator Studio shell. A plain link with a
 * dot, not a dropdown: the inbox is one route away and a preview panel would
 * duplicate the whole thread list.
 *
 * Rendered only when the tenant has messaging on — the shell decides that, so
 * this component never has to know about the flag.
 */
export function MessagesBell() {
  const navigate = useNavigate();
  const q = useQuery({
    queryKey: ['creator-chat', 'unread-count'],
    queryFn: getCreatorChatUnreadCount,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
  const count = q.data?.count ?? 0;
  return (
    <button
      type="button"
      aria-label={count > 0 ? `Messages (${count} unread)` : 'Messages'}
      onClick={() => navigate('/messages')}
      className="relative flex h-9 w-9 flex-none items-center justify-center rounded-md text-muted-foreground hover:bg-muted"
    >
      <MessageCircle className="h-5 w-5" />
      {count > 0 && (
        <span className="absolute right-1 top-1 h-2 w-2 rounded-full bg-primary" aria-hidden />
      )}
    </button>
  );
}
